﻿import { useState, useCallback } from 'react';
import { api } from '@/services/api';

export interface CrudRecord {
  [key: string]: string;
}

interface CrudResponse {
  records: CrudRecord[];
  primaryKeys: { field: string; autoincrement: boolean }[];
}

export function useCrudTables() {
  const [records, setRecords] = useState<CrudRecord[]>([]);
  const [primaryKeys, setPrimaryKeys] = useState<{ field: string; autoincrement: boolean }[]>([]);
  const [columns, setColumns] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchRecords = useCallback(async (tiporecord: string) => {
    setLoading(true);
    try {
      const data = await api.post<CrudResponse>(
        'crud/crud-api/' + tiporecord + '/get',
        { filters: {}, sortBy: '', sortOrder: '', page: 0, numelem: 100 }
      );
      const recs = data?.records || [];
      setRecords(recs);
      setPrimaryKeys(data?.primaryKeys || []);
      setColumns(recs.length > 0 ? Object.keys(recs[0]) : []);
    } catch {
      setRecords([]);
      setColumns([]);
      setPrimaryKeys([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const insertRecord = useCallback(async (tiporecord: string, record: CrudRecord): Promise<boolean> => {
    try {
      await api.post('crud/crud-api/create', [record], { params: { recordType: tiporecord } });
      return true;
    } catch { return false; }
  }, []);

  const updateRecord = useCallback(async (tiporecord: string, record: CrudRecord): Promise<boolean> => {
    try {
      await api.post('crud/crud-api/update', [record], { params: { recordType: tiporecord } });
      return true;
    } catch { return false; }
  }, []);

  return { records, columns, primaryKeys, loading, fetchRecords, insertRecord, updateRecord };
}
